import { makeStyles } from '@material-ui/core';
import { useEffect } from 'react';

import { NemuruDialog } from '@/components/shared/components/NemuruDialog';
import { SearchBarControls } from '@/components/shared/components/SuperSearchBar/components/SearchBarControls/SearchBarControls';
import { SearchResultList } from '@/components/shared/components/SuperSearchBar/components/SearchResultList/SearchResultList';
import { useKeyboard } from '@/components/shared/components/SuperSearchBar/hooks/useKeyboard';
import { useSuperSearchBar } from '@/components/shared/components/SuperSearchBar/hooks/useSuperSearchBar';
import { usePageContext } from '@/contexts/PageContext/PageContext';

export const SuperSearchBarDialog = () => {
  const {
    state: { showSuperSearchBar },
    actions: { setShowSuperSearchBar },
  } = usePageContext();

  const {
    searchBarState,
    setSearchBarState,
    searchResults,
    setSearchResults,
    sortByOptions,
    filterByTypeOptions,
    filterByDateOptions,
    requestLoading,
    paginationProps,
  } = useSuperSearchBar();

  const { platform, selectedResult, onNavigate } = useKeyboard({
    setOpened: setShowSuperSearchBar,
    searchResults,
    paginationProps,
  });

  const classes = useStyles();

  useEffect(() => {
    setTimeout(() => {
      if (!showSuperSearchBar) setSearchResults(undefined);
    }, 100);
  }, [showSuperSearchBar]);

  return (
    <NemuruDialog
      opened={showSuperSearchBar}
      setOpened={setShowSuperSearchBar}
      removeDefaultButton={true}
      hideButtonsWrapper
      boxProps={{ px: 2, py: 0, height: '100%' }}
      dialogProps={{ className: classes.root, style: { position: 'absolute', top: 0 } }}
    >
      <SearchBarControls
        searchBarState={searchBarState}
        filterByTypeOptions={filterByTypeOptions}
        sortByOptions={sortByOptions}
        filterByDateOptions={filterByDateOptions}
        setSearchBarState={setSearchBarState}
        requestLoading={requestLoading}
      />

      {(requestLoading || searchResults) && (
        <SearchResultList
          requestLoading={requestLoading}
          searchResults={searchResults}
          selectedResult={selectedResult}
          searchBarState={searchBarState}
          onNavigate={onNavigate}
          toggleDialog={() => setShowSuperSearchBar(!showSuperSearchBar)}
          paginationProps={paginationProps}
          platform={platform}
        />
      )}
    </NemuruDialog>
  );
};

const useStyles = makeStyles({
  root: {
    '& .MuiPaper-root': { position: 'absolute', top: '1vh', maxHeight: '92vh' },
    '& .MuiDialog-paperWidthSm': { maxWidth: '660px' },
  },
});
